import Instance from '../../../Axios';

// New Actions for the app

const GetMenus = () => async (dispatch) => {
  await Instance()
    .get(`/backend/menus`)
    .then(({ data }) => {
      console.log(data);
      dispatch({ type: 'GET_MENUS', payload: data.yData });
    })
    .catch((err) => {
      console.log(err);
    });
};

export default GetMenus;
